<template>
  <div id="repair">
    <div class="container">
      <!-- Container -->
      <div class="section-title text-center center zeropadding">
        <h2>{{ $t("index.repair") }}</h2>
        <div class="line">
          <hr />
        </div>
        <div class="clearfix"></div>
        <small
          ><em>{{ $t("index.repairin") }}</em></small
        >
      </div>
      <div class="space"></div>
      <div class="main">
        <div class="circle_parent" @click="jump('online')">
          <div class="circle_small">
            <svg
              t="1715319031384"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4731"
              width="50"
              height="50"
            >
              <path
                d="M398.275377 445.378673l0-54.041824c0-14.211676-11.520381-25.732058-25.732058-25.732058s-25.732058 11.520381-25.732058 25.732058l0 54.041824c0 14.211676 11.520381 25.732058 25.732058 25.732058S398.275377 459.59035 398.275377 445.378673z"
                fill="#ffffff"
                p-id="4732"
              ></path>
              <path
                d="M695.006546 445.378673l0-54.041824c0-14.211676-11.521404-25.732058-25.732058-25.732058s-25.732058 11.520381-25.732058 25.732058l0 54.041824c0 14.211676 11.521404 25.732058 25.732058 25.732058S695.006546 459.59035 695.006546 445.378673z"
                fill="#ffffff"
                p-id="4733"
              ></path>
              <path
                d="M686.430216 574.623269c4.976338-9.425673 1.37123-21.101597-8.05342-26.078958-9.428743-4.976338-21.100574-1.370207-26.078958 8.05342-24.722054 46.814212-72.949452 75.895551-125.860523 75.895551-51.577702 0-99.222839-28.018124-124.341936-73.119321-5.187139-9.31311-16.939811-12.656251-26.251897-7.470135-9.312086 5.185093-12.656251 16.939811-7.470135 26.250874 31.927153 57.326637 92.493577 92.937692 158.063969 92.937692C593.699232 671.093415 655.004483 634.128525 686.430216 574.623269z"
                fill="#ffffff"
                p-id="4734"
              ></path>
              <path
                d="M933.020404 433.410084c-16.08535-16.839527-38.09462-26.377764-65.531506-28.444842-14.829753-67.391876-47.028083-129.272225-94.248547-179.482791-32.584116-34.648125-70.559009-61.865-112.870674-80.893378C616.469841 124.845403 569.831638 114.834398 521.750573 114.834398c-48.073902 0-94.708012 10.011005-138.605801 29.753651-42.308595 19.029402-80.281441 46.245254-112.863511 80.893378-46.608527 49.563836-78.58173 110.496603-93.663216 176.878476-26.077935 2.509147-47.111994 11.936867-62.619176 28.172643-20.419052 21.376866-29.797653 53.446259-27.875884 95.318926 2.186805 47.460941 17.055444 81.502245 44.193525 101.18247 11.93482 8.654101 32.786731 20.160155 75.881225 20.160155 7.181563 0 13.43294-3.930519 16.756639-9.749038 6.894014-5.148253 9.729595-14.468526 6.303566-22.790052-17.460674-42.415019-23.952528-75.881225-23.952528-123.478266 0-90.443895 33.062-175.412079 93.095281-239.252059 59.725266-63.512523 139.045823-98.491175 223.350904-98.491175 84.315314 0 163.643034 34.978652 223.372394 98.491175 60.035328 63.838957 93.098351 148.807141 93.098351 239.252059 0 127.479393-67.314105 243.674788-172.923398 301.07101-8.329712-7.393387-19.290345-11.890818-31.306007-11.890818-26.045189 0-47.168276 21.12104-47.168276 47.168276 0 26.059516 21.123087 47.180556 47.168276 47.180556 26.060539 0 47.181579-21.122063 47.181579-47.180556l0-0.001023c55.398728-29.512151 102.506629-73.804936 136.931672-128.968303 9.709129-15.558347 18.257829-31.768541 25.617447-48.500621 20.510126-0.209778 49.201585-2.901073 72.980151-20.143783 27.13808-19.679202 42.005696-53.721529 44.192501-101.18554C962.819081 486.856343 953.440479 454.78695 933.020404 433.410084zM124.681162 524.078083c-1.419326-30.92636 4.377704-53.428863 17.229406-66.884316 6.882757-7.206122 16.179494-12.122085 27.742854-14.732539-1.942235 16.030092-2.948145 32.290427-2.948145 48.715515 0 44.140313 5.329379 78.562287 18.523889 116.324332C154.912697 603.700515 127.606795 587.577303 124.681162 524.078083zM922.338111 526.953573c-3.03001 65.780169-32.223912 80.723509-63.824631 83.789335 12.072967-38.241976 18.307971-78.533634 18.307971-119.566166 0-15.665795-0.89744-31.187303-2.665713-46.495964 13.06762 2.387373 23.444968 7.528464 30.953989 15.390525C917.960407 473.525734 923.757436 496.030283 922.338111 526.953573z"
                fill="#ffffff"
                p-id="4735"
              ></path>
            </svg>
          </div>
          <div class="circle_main">{{ $t("repair.online") }}</div>
        </div>
        <div class="circle_parent" @click="jump('click')">
          <div class="circle_small">
            <svg
              t="1715319643294"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3567"
              width="50"
              height="50"
            >
              <path
                d="M656.8 549.6c88.8-6.2 159.2-80.6 159.2-171 0-15.8-2.2-31.4-6.6-47.2-2-6.6-6.8-11.4-13.4-13.2-6.6-1.6-13.4 0.4-18.4 5L744.8 356c-20.6 20.6-56.6 20.6-77.4 0-21.4-21.2-21.4-56.4 0-77.6l32.8-32.8c5-5 6.6-11.8 5-18.4-1.6-6.6-6.6-11.8-13.2-13.4-15.4-4.2-31.4-6.6-46.8-6.6-94.4 0-171 77-171 171.4 0 8.8 0.6 18.4 2.2 27.6l-22.6 20.6-108.8-108.8c10.2-21.2 6.6-47.6-11.2-64.8l-40-40c-3.6-3.6-8.6-5.6-13.4-5.6s-9.8 2-13.4 5.6l-53.8 53.8c-7.6 7.6-7.6 19.4 0 26.8l40 40c10.8 10.8 25.2 16.8 40.4 16.8 8.6 0 17-2 24.6-5.6l107.4 107.4-184.4 169c-21.6 21.6-33.4 50.2-33.4 81 0 30.4 11.8 59.4 33.4 81 21.6 21.6 50.2 33.4 80.6 33.4 30.4 0 59-11.8 81.2-34l129.8-141.8 153.6 153.6c14 14.4 33.8 22.2 53.8 22.2 20.4 0 39.4-7.8 53.8-22.2 14.4-14 22.2-33.8 22.2-53.8 0-20.4-7.8-39.6-22.2-53.8l-137.2-137.4z m-350-242.8c-7.2 7.2-19.6 7.2-26.8 0l-26.6-26.6 26.8-26.8 26.6 26.6c7.2 7.2 7.2 19.4 0 26.8z m66.8 452c-29.2 29.2-79.6 29.2-108.8 0-14.4-14.4-22.6-34-22.6-54.4 0-20.6 7.8-40 22-53.8l240.8-228.8c0.4-0.4 0.4-0.4 0.4-0.6 0.4-0.4 1-1 1.4-1.6 0.4-0.4 0.6-1 1-1.4 0.4-0.6 0.6-1 1-1.6 0.4-0.6 0.6-1 1-1.6 0.4-0.6 0.4-1.4 0.6-1.6 0.4-0.6 0.4-1.4 0.4-1.6 0-0.6 0.4-1.4 0.4-2v-3.6c0-0.6 0-1.4-0.4-2v-0.6c-2.2-10.4 0.6-16.4 0.6-26.2 0-74.8 61.6-135 136.4-134.6l-6.2 6.6c-36.4 36.8-36.4 96.4 0 132.8 17.6 17.6 41.2 27.6 66.2 27.6 25.2 0 48.4-9.8 66.2-27.6l6.2-6.2v2c0 74.4-61.2 137-135.4 137-10.2 0-19.6 0.6-29.4-1.6h-0.6c-0.6 0-1.4-0.4-2-0.4h-3.6c-0.6 0-1 0-1.6 0.4-0.6 0-1.4 0.4-2 0.6-0.4 0-1 0.4-1.4 0.6l-2 1c-0.4 0.4-1 0.6-1.4 0.6-0.6 0.4-1 0.6-1.6 1.4-0.6 0.4-1 1-1.4 1.4l-0.6 0.6-223.6 239.2z m392.8 8.8c-14.4 14.4-39.4 14.4-53.8 0l-156-157.2 57.6-56 152.4 159.6c7.2 7.2 11.2 16.8 11.2 26.8-0.2 9.8-4.2 19.6-11.4 26.8z m-445-97c-17.6 0-31.8 14.4-31.8 31.8 0 17.6 14 31.8 31.8 31.8 17.6 0 31.8-14.4 31.8-31.8s-14.4-31.8-31.8-31.8z m0 0"
                p-id="3568"
                fill="#ffffff"
              ></path>
            </svg>
          </div>
          <div class="circle_main">{{ $t("repair.click") }}</div>
        </div>
        <div class="circle_parent" @click="jump('self')">
          <div class="circle_small">
            <svg
              t="1715335138193"
              class="icon"
              viewBox="0 0 1025 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6598"
              width="30"
              height="30"
            >
              <path
                d="M944.876 688.912v-570.73a39.706 39.706 0 0 0-39.418-39.634H118.182a39.634 39.634 0 0 0-39.346 39.634v570.73h866.04z m0 59.09H78.836v157.816a39.058 39.058 0 0 0 39.346 38.914h787.276a39.058 39.058 0 0 0 39.418-38.914V748.003zM78.836 0h866.04a78.692 78.692 0 0 1 78.692 78.548v866.184A78.836 78.836 0 0 1 944.876 1024H78.836A79.268 79.268 0 0 1 0.072 944.732V78.548A78.764 78.764 0 0 1 78.836 0z m490.02 385.531c2.235 1.442 4.397 3.603 6.342 5.045l139.152 139.8a39.058 39.058 0 0 1 0 55.487l-13.908 13.692a38.481 38.481 0 0 1-55.632 0L505.66 460.475a57.65 57.65 0 0 1-5.117-6.485 147.439 147.439 0 0 1-197.666-196.008l91.447 91.518a20.61 20.61 0 0 0 27.816 0l41.796-41.796a20.105 20.105 0 0 0 0-28.104l-91.519-91.518a147.655 147.655 0 0 1 196.513 197.45z m-48.353 436.696a25.582 25.582 0 1 1 0 51.164H141.53a25.582 25.582 0 0 1-25.078-26.663 25.005 25.005 0 0 1 25.078-24.501H520.43z m361.68 0a25.582 25.582 0 1 1 0 51.164H675.508a25.582 25.582 0 1 1 0-51.164h206.673z"
                p-id="6599"
                fill="#ffffff"
              ></path>
            </svg>
          </div>
          <div class="circle_main">{{ $t("repair.common") }}</div>
        </div>
      </div>
      <div class="main_bottom">
        <!-- 故障汇总 -->
        <div class="circle_parent" @click="jump('Summary')">
          <div class="circle_small">
            <svg
              t="1715335138193"
              class="icon"
              viewBox="0 0 1025 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6598"
              width="30"
              height="30"
            >
              <path
                d="M944.876 688.912v-570.73a39.706 39.706 0 0 0-39.418-39.634H118.182a39.634 39.634 0 0 0-39.346 39.634v570.73h866.04z m0 59.09H78.836v157.816a39.058 39.058 0 0 0 39.346 38.914h787.276a39.058 39.058 0 0 0 39.418-38.914V748.003zM78.836 0h866.04a78.692 78.692 0 0 1 78.692 78.548v866.184A78.836 78.836 0 0 1 944.876 1024H78.836A79.268 79.268 0 0 1 0.072 944.732V78.548A78.764 78.764 0 0 1 78.836 0z m490.02 385.531c2.235 1.442 4.397 3.603 6.342 5.045l139.152 139.8a39.058 39.058 0 0 1 0 55.487l-13.908 13.692a38.481 38.481 0 0 1-55.632 0L505.66 460.475a57.65 57.65 0 0 1-5.117-6.485 147.439 147.439 0 0 1-197.666-196.008l91.447 91.518a20.61 20.61 0 0 0 27.816 0l41.796-41.796a20.105 20.105 0 0 0 0-28.104l-91.519-91.518a147.655 147.655 0 0 1 196.513 197.45z m-48.353 436.696a25.582 25.582 0 1 1 0 51.164H141.53a25.582 25.582 0 0 1-25.078-26.663 25.005 25.005 0 0 1 25.078-24.501H520.43z m361.68 0a25.582 25.582 0 1 1 0 51.164H675.508a25.582 25.582 0 1 1 0-51.164h206.673z"
                p-id="6599"
                fill="#ffffff"
              ></path>
            </svg>
          </div>
          <div class="circle_main">故障汇总</div>
        </div>
        <!-- 维修保养 -->
        <div class="circle_parent" @click="jump('maintain')">
          <div class="circle_small">
            <svg
              t="1715335138193"
              class="icon"
              viewBox="0 0 1025 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6598"
              width="30"
              height="30"
            >
              <path
                d="M944.876 688.912v-570.73a39.706 39.706 0 0 0-39.418-39.634H118.182a39.634 39.634 0 0 0-39.346 39.634v570.73h866.04z m0 59.09H78.836v157.816a39.058 39.058 0 0 0 39.346 38.914h787.276a39.058 39.058 0 0 0 39.418-38.914V748.003zM78.836 0h866.04a78.692 78.692 0 0 1 78.692 78.548v866.184A78.836 78.836 0 0 1 944.876 1024H78.836A79.268 79.268 0 0 1 0.072 944.732V78.548A78.764 78.764 0 0 1 78.836 0z m490.02 385.531c2.235 1.442 4.397 3.603 6.342 5.045l139.152 139.8a39.058 39.058 0 0 1 0 55.487l-13.908 13.692a38.481 38.481 0 0 1-55.632 0L505.66 460.475a57.65 57.65 0 0 1-5.117-6.485 147.439 147.439 0 0 1-197.666-196.008l91.447 91.518a20.61 20.61 0 0 0 27.816 0l41.796-41.796a20.105 20.105 0 0 0 0-28.104l-91.519-91.518a147.655 147.655 0 0 1 196.513 197.45z m-48.353 436.696a25.582 25.582 0 1 1 0 51.164H141.53a25.582 25.582 0 0 1-25.078-26.663 25.005 25.005 0 0 1 25.078-24.501H520.43z m361.68 0a25.582 25.582 0 1 1 0 51.164H675.508a25.582 25.582 0 1 1 0-51.164h206.673z"
                p-id="6599"
                fill="#ffffff"
              ></path>
            </svg>
          </div>
          <div class="circle_main">维修保养</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

let router = useRouter();

localStorage.setItem("router", "repair");

function jump(url) {
  if (url == "online") {
    let link = document.createElement("a");
    //创建一个a标签
    link.style.display = "none";
    //将a标签隐藏
    link.href = "https://gncss.bodor.com/p/102308#/chat";
    link.setAttribute("target", "_blank");
    // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
    document.body.appendChild(link);
    //将上面创建的a标签加入到body的尾部
    link.click();
  } else {
    router.push(`/${url}`);
  }
}
</script>

<style scoped>
#repair {
  padding: 100px 100px;
  background-color: #f7f9fa;
}
.zeropadding {
  padding: 0px;
}
.main {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  padding: 0px 100px;
}
.circle_parent {
  width: 300px;
  height: 300px;
  position: relative;
}
.circle_small {
  width: 75px;
  height: 75px;
  border-radius: 100%;
  background-color: rgba(75, 145, 255, 1);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 25%;
  top: 25%;
  transform: translate(-50%, -50%);
  z-index: 100;
  transition: all 0.4s;
  cursor: pointer;
}
.circle_main {
  width: 200px;
  height: 200px;
  border-radius: 100%;
  background-color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  color: black;
  font-size: 32px;
  cursor: pointer;
  transition: all 0.4s;
  z-index: 1;
  box-shadow: 0px 0px 16px 1px rgba(0, 0, 0, 0.2);
  text-align: center; /* 将文本居中 */
  white-space: pre-wrap;
}
.circle_parent:hover .circle_main {
  width: 75px;
  height: 75px;
  left: 25%;
  top: 25%;
  font-size: 16px;
}
.circle_parent:hover .circle_small {
  width: 200px;
  height: 200px;
  left: 50%;
  top: 50%;
}
.online {
}
.common {
}
.main_bottom {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}
</style>
